import Axios from "axios";
// import store from "../store";
let instance = null;

const BASE_API = "https://api.monday.com/v2";

const HTTP = Axios.create({
  baseURL: BASE_API,
  headers: {
    Authorization:
      "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjQ2NjExNDcxLCJhYWkiOjExLCJ1aWQiOjExNzg0NzE5LCJpYWQiOiIyMDIwLTA1LTI5VDIxOjI3OjE4LjAwMFoiLCJwZXIiOiJtZTp3cml0ZSIsImFjdGlkIjo1Mjc1NjE0LCJyZ24iOiJ1c2UxIn0.DL20pLCeQLOk8U7PAXh4gktC1ACPf_jJQOHXNS7DrRc",
    "Content-Type": "application/json"
  }
});

class Service {
  constructor() {
    if (!instance) instance = this;
    return instance;
  }

  async toMonday({ query }) {
    return HTTP.post("/", {
      query: query
    }).then(res => res);
  }
}

export const apiMonday = new Service();
